import { useMemo } from 'react';
import { useLocation } from 'react-router';

export function useReferPath() {
  const location = useLocation();
  return useMemo<string | undefined>(() => location.state ? location.state.referPath : undefined, [location.state]);
}
